export const SET_HAS_MFR = 'MFR/SET_HAS_MFR';
export const SET_MY_FAVORITE_RADIO = 'MFR/SET_MY_FAVORITE_RADIO';
export const SET_MY_FAVORITE_RADIO_NAME = 'MFR/SET_MY_FAVORITE_RADIO_NAME';
export const SET_LISTEN_HISTORY = 'MFR/SET_LISTEN_HISTORY';
